/**
 * Czytelny komunikat odrzuconego zapisu zadania — JEDNO źródło dla formularza (`TaskDetail`) i
 * tablicy Kanban (`useTaskKanbanMove`). Oba miejsca wysyłają ten sam zapis (`PATCH /api/tasks/:id`),
 * więc odrzucenie ma brzmieć tak samo, niezależnie od tego, czy zmiana przyszła z formularza, czy
 * z przeciągnięcia karty.
 *
 * Kolejność: walidacja pól (nazwy pól z katalogu), odrzucone wartości słownikowe, potem kody
 * serwera zadań (`taskErrorMessage`); kod nieznany albo brak odpowiedzi → jawny komunikat ogólny
 * „nie udało się zapisać". Zawsze zwraca tekst. Podświetlanie pól formularza zostaje w formularzu.
 */

import type { TFunction } from 'i18next';

import { extractErrorCode } from '@/lib/errors';
import { mapDictionarySaveError } from '@/lib/records/save-error-message';
import { taskErrorMessage } from '@/lib/tasks/task-api';
import { buildValidationToastMessage } from '@/lib/validation-toast';

export function taskSaveErrorMessage(
  err: unknown,
  t: TFunction,
  fieldLabel: (field: string) => string | null,
  numberingFieldLabel?: (slug: string) => string,
): string {
  if (extractErrorCode(err) === 'VALIDATION_ERROR') {
    return (
      buildValidationToastMessage(err, fieldLabel, t) ??
      t('tenant.tasks.detail.toast.validationError')
    );
  }
  const dictionaryMsg = mapDictionarySaveError(err, t);
  if (dictionaryMsg !== null) return dictionaryMsg;
  return taskErrorMessage(err, t, 'tenant.tasks.detail.toast.saveError', numberingFieldLabel);
}
